interface LegalEntityBaseCurrency {
  id: number
  name: string
}

export interface LegalEntitySummaryWithBaseCurrencyConstructor {
  id: number
  uuid: string
  name: string
  baseCurrency: LegalEntityBaseCurrency
}

export class LegalEntitySummaryWithBaseCurrency {
  readonly id: number
  readonly uuid: string
  readonly name: string
  readonly baseCurrency: LegalEntityBaseCurrency

  constructor(data: LegalEntitySummaryWithBaseCurrencyConstructor) {
    this.id = data.id
    this.uuid = data.uuid
    this.name = data.name
    this.baseCurrency = data.baseCurrency
  }
}
